export default __webpack_public_path__ + "static/media/bra-material-4.8447fe12.webp";